module.exports = __webpack_public_path__ + "img/bust_dart_length.d3d0f8b6.png";